import React from 'react';
import styled from 'styled-components';
import './shootingstarstyle2.css';

const Star = styled.div<{
  color: string;
}>`
  position: absolute;
  top: 0;
  left: 0;
  height: 1.5px;
  background: linear-gradient(
    -45deg,
    ${({ color }) => color},
    rgba(255, 255, 255, 0)
  );
  filter: drop-shadow(0 0 6px ${({ color }) => color});
  animation: tail 2s ease-in-out infinite, shooting 2s ease-in-out infinite;

  &::after,
  &::before {
    position: absolute;
    content: '';
    top: calc(50% - 1px);
    right: 0;
    height: 1px;
    background: linear-gradient(
      -45deg,
      rgba(255, 255, 255, 0),
      ${({ color }) => color},
      rgba(255, 255, 255, 0)
    );
    transform: translateX(50%) rotateZ(45deg);
    animation: shining 2s ease-in-out infinite;
  }

  &::after {
    transform: translateX(50%) rotateZ(-45deg);
  }
`;

type Props = { color: string };

function ShootingStar({ color }: Props) {

  return (
    <div className="sky">
      {Array.from({ length: 10 }).map((_, index) => (
        <Star className="star" key={index} color={color} />
      ))}
    </div>
  );
}

export default ShootingStar;
